var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.blockClass},[_c('div',{staticClass:"dummy"}),_c('div',{staticClass:"content",style:({ backgroundImage: 'url(' + _vm.img + ')' })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }